
import { Component, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CustomizerColorsAutoUpdateComponent, CustomizerComponentHeaderComponent } from '@app/customizer/components';
import { PreciousMetalInfoComponent } from '@app/customizer/components/precious-metal-info/precious-metal-info.component';
import { BrandModeService } from '@services/brandmode.service';
import { ConfigurationService } from '@services/configuration.service';
import { ComponentVariantFromApiModel } from '@models/api-models/component-variant-fromapi';
import { ComponentVariantModel } from '@models/component-variant';
import { VariantColorModel } from '@models/variant-color';
import { DataApiService } from '@services/data-api.service';
import { EventsService } from '@services/events.service';
import { ComponentVariantChangeModel } from '../../../../_models/component-variant-change';
import { AngleConstants } from '../../../../shared/angle-constants';
import { BaseCustomizerComponent } from '../../../../shared/base-customizer-component';

@Component({
    template: `
      <customizer-component-header [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">
        @if (selectableVariants.length) {
          <customizer-colors-auto-update
            [selected]="getSelectedVariant.VariantColor"
            [selectedColorGroup]="currentColorGroup"
            [variants]="selectableVariants"
            [editMode]="state === customizerStateEnum.EDITORDER"
            [matchableColors]="matchableColors"
            [useColorGroup]="menu.contentGrouping"
            (colorMatchChange)="matchColors($event)"
            (selectedColorGroupChange)="onSelectGroup($event)"
            (selectedColorChange)="onSelect($event)"
            [(scrollPosition)]="menu.menuDetails.scrollPosition"
            [variantOrModelIsNew]="variantOrModelIsNew"
            [extendedInformation]="extendedInformation"
            [extendedInformationTable]="false"
            [matchColor]="menu.matchColor"
            >
          </customizer-colors-auto-update>
        }
      </customizer-component-header>
      <precious-metal-info></precious-metal-info>
      `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    PreciousMetalInfoComponent,
    CustomizerColorsAutoUpdateComponent,
    CustomizerComponentHeaderComponent
]
})
export class PreciousMetalComponent extends BaseCustomizerComponent {

	public selectableVariants: Array<ComponentVariantFromApiModel> = [];
	public extendedInformation: boolean = false;

	constructor(
		public override events: EventsService,
		public apiService: DataApiService,
		public override configurationService: ConfigurationService,
		private brandmodeService: BrandModeService
	) {
		super(events, apiService, configurationService);
		this.extendedInformation = this.brandmodeService.isPrecious;
	}

	async initData() {
		this.events.showLoader(true);

		this.selectableVariants = await this.fetchData();

		this.events.showLoader(false);
	}

	onChanges(changes: SimpleChanges): void {
		this.setImageSliderByName(AngleConstants.Perspective);
	}

	async fetchData(): Promise<Array<ComponentVariantFromApiModel>> {
		const variants = this.getCurrentVariants;
		let variantsFromApi: ComponentVariantFromApiModel[] | undefined = []

		for (const variant of variants) {
			const apidata = await this.configurationService.getVariants(this.configuration?.ModelConfigurationUuid, this.modelGroup, undefined, variant.Uuid, variant.VariantSize?.Uuid);
			variant.VariantColorViewed = true;
			variantsFromApi = apidata ? [...variantsFromApi, ...apidata] : [...variantsFromApi];
		}

		await this.RunDisablingSystem(variantsFromApi);

		return variantsFromApi;
	}

	onSelect(color: VariantColorModel) {
		this.events.showLoader(true);

		this.getCurrentVariants.forEach(variant => {
			const currentVariants = this.selectableVariants.find(x => x.Code == variant.Code);

			if (!currentVariants)
				return;

			const selectedColor = currentVariants.VariantSizes[0].VariantColors.find(x => x.ColorUuid == color.ColorUuid);

			const newVariant = Object.assign(new ComponentVariantModel(variant.Discontinued, variant.New), variant);
			const oldVariant = Object.assign(new ComponentVariantModel(variant.Discontinued, variant.New), variant);
			newVariant.VariantColor = selectedColor;
			this.updateVariant(new ComponentVariantChangeModel(oldVariant, newVariant, null));
		});

	}

}
